import { getAccountConfig } from '@accountFederation/config/accountConfig';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { ResponsibleGamingPageElement } from '@src/config/shell/localConfigTypes';

export function isResponsibleGamingElementEnabled(elementName: ResponsibleGamingPageElement): boolean {
    const responsibleGamingElementsOverride = getAccountConfig().responsibleGamingElementsOverride;
    if (responsibleGamingElementsOverride[elementName] !== undefined) {
        return responsibleGamingElementsOverride[elementName] as boolean;
    } else {
        return shellLocalConfig.responsibleGamingPageElements[elementName];
    }
}
